import AbstractRequestTask from "../AbstractRequestTask";
import device from "../../../devices/device";
import Utils from '../../../utils/Utils';
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';


class ShowCaptchaTask extends AbstractRequestTask {
    constructor(params = {}) {
        super();
        this.ownParams = params;
    }

    getParams() {
        const params = super.getParams();
        return Object.assign({}, params, this.ownParams);
    }

    getUrl() {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");

      return `${http}${url}/services/user/showcaptcha`;
    }

    getImageUrl(){
        return `${this.getUrl()}?${Utils.buildQueryParams(this.getParams())}`
    }

    getShowErrorModal(){
        return ENABLE_MODAL_RETRIES;
    }
}


export default ShowCaptchaTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/ShowCaptchaTask.js